import React, { useEffect, useState } from "react";
import { CommonPropertyProps } from "schemas/elements";
import SearchSelectContainer from "components/FormDesigner/elements/SearchSelect/SearchSelectContainer";
import { IdData } from "hooks/FormDesigner/useElementList";
import { useTranslation } from "react-i18next";
import { SearchSelectOptionProps } from "@alm/flow-ds/components";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: SearchSelectOptionProps | undefined;
	idList: IdData;
	disabledPlaceholder?: string;
	entityUri?: SearchSelectOptionProps;
	isSearchView?: boolean;
};

export default ({
	isEmu,
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	idList,
	nestedField,
	disabledPlaceholder,
	entityUri,
	isSearchView,
}: Props) => {
	const { t } = useTranslation();
	const [requestUri, setRequestUri] = useState(entityUri);
	useEffect(() => {
		if (
			(field === "label" ||
				// @ts-expect-error overwriteDataWith is only a part of search so errors here
				field === "overwriteDataWith") &&
			nestedField === "search" &&
			value !== null &&
			value !== undefined &&
			(!entityUri || requestUri !== entityUri)
		) {
			updateStore({
				elementIndex,
				property: field,
				nestedField,
				value: null,
			});
			setRequestUri(entityUri);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [field, requestUri, entityUri]);

	const props = {
		updateStore,
		field,
		required,
		value,
		desc,
		validation,
		elementIndex,
		options: idList as SearchSelectOptionProps[],
		disabled:
			(!isSearchView && idList) ||
			(isSearchView && idList !== undefined && idList.length > 0)
				? false
				: true,
		nestedField,
		disabledPlaceholder: isSearchView
			? t("formDesigner.placeholders.requestUriSearchRelation")
			: disabledPlaceholder,
		creatable: true,
		monospaceFont: !isEmu,
	};

	return <SearchSelectContainer {...props} />;
};
